// Author liang gang qiang
// Date 2021-11-25 16:25:20

class MintalMesPrdCraftMaterialConfig {
constructor({
        id = null,
        craftId = '',
        craftName = '',
        materialId = '',
        mstMaterialName = '',
        mstMaterialUnit = '',
        rate = '',
        remark = ''}
= {}) {
    this.id = id;
    this.craftId = craftId;
    this.craftName = craftName;
    this.materialId = materialId;
    this.mstMaterialName = mstMaterialName;
    this.mstMaterialUnit = mstMaterialUnit;
    this.rate = rate;
    this.remark = remark;
}
}

function newEntity() {
return new MintalMesPrdCraftMaterialConfig();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.prd.mintalMesPrdCraftMaterialConfig.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'craftName',
        label: 'label.mintal.prd.mintalMesPrdCraftMaterialConfig.grid.craftName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstMaterialCode',
        label: 'label.mintal.prd.mintalMesPrdCraftMaterialConfig.grid.mstMaterialCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstMaterialName',
        label: 'label.mintal.prd.mintalMesPrdCraftMaterialConfig.grid.mstMaterialName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstMaterialUnit',
        label: 'label.mintal.prd.mintalMesPrdCraftMaterialConfig.grid.mstMaterialUnit',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'rate',
        label: 'label.mintal.prd.mintalMesPrdCraftMaterialConfig.grid.rate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdCraftMaterialConfig.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    craftIdFilter : '',
    craftNameFilter : '',
    materialIdFilter : '',
    mstMaterialNameFilter : '',
    rateFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'craftNameFilter',
        label: 'label.mintal.prd.mintalMesPrdCraftMaterialConfig.filter.craftName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdCraft'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"craftId": "id"}'
                }
        },
        {
        key: 'mstMaterialNameFilter',
        label: 'label.mintal.prd.mintalMesPrdCraftMaterialConfig.filter.mstMaterialName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesMstMaterial'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"materialId": "id"}'
                }
        },
        {
        key: 'rateFilter',
        label: 'label.mintal.prd.mintalMesPrdCraftMaterialConfig.filter.rate',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'craftName',
        label: 'label.mintal.prd.mintalMesPrdCraftMaterialConfig.entity.craftName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdCraft'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"craftId": "id"}'
                }
        },
        {
        key: 'mstMaterialName',
        label: 'label.mintal.prd.mintalMesPrdCraftMaterialConfig.entity.mstMaterialName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesMstMaterial'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"materialId": "id", "materialUnit": "unit"}'
                }
        },
        {
        key: 'mstMaterialUnit',
        label: 'label.mintal.prd.mintalMesPrdCraftMaterialConfig.entity.mstMaterialUnit',
        sortable: true,
        disabled: true,
        form: {
        type: 'input'
                }
        },
        {
        key: 'rate',
        label: 'label.mintal.prd.mintalMesPrdCraftMaterialConfig.entity.rate',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdCraftMaterialConfig.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {MintalMesPrdCraftMaterialConfig, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
